
import { Box, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { formatPrice, getFormatedDate } from "../../utils/common";
import { RUPEES_SYMBOL } from "../../utils/constant";
import { ROUTES } from "../../utils/routes";
import { getInfluencerSubscriptionDetails } from "./action";

const DetailsInfluencerSubscription = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { id } = useParams();
    const [details, setDetails] = useState(null);

    useEffect(() => {
        if (id) {
            dispatch(getInfluencerSubscriptionDetails(id, setDetails));
        }
    }, [id, dispatch]);

    if (!details) {
        return <Typography>Loading...</Typography>;
    }

    return (
        <>
            <Stack direction={"row"} alignItems={"center"} spacing={3} mb={2}>
                <Stack
                    direction={"row"}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                    sx={{
                        minHeight: '42px', paddingX: '16px', width: '100%'
                    }}
                >
                    <Typography variant="h1" className="page-title">
                        Subscription Details
                    </Typography>
                    <Stack
                        className="backText"
                        direction={"row"}
                        gap={1}
                        alignItems={"center"}
                        sx={{ cursor: "pointer" }}
                        onClick={() => navigate(ROUTES.INFLUENCER_SUBSCRIPTION_LIST)}
                    >
                        <svg
                            width="16"
                            height="12"
                            viewBox="0 0 16 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M8.5 7.66667L5.16667 4.33333L8.5 1M4.33333 7.66667L1 4.33333L4.33333 1"
                                stroke="#0077FF"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M5.1665 4.33331H10.9998C11.8839 4.33331 12.7317 4.6845 13.3569 5.30962C13.982 5.93474 14.3332 6.78259 14.3332 7.66665C14.3332 8.5507 13.982 9.39855 13.3569 10.0237C12.7317 10.6488 11.8839 11 10.9998 11H10.1665"
                                stroke="#0077FF"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                        <Typography variant="h5" color={"primary"}>
                            Back
                        </Typography>

                    </Stack>

                </Stack>
            </Stack>

            <div className="card p-4 mx-3">
                <div className="row g-3">
                    <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                        <div className="dataView">
                            <label>Influencer Name</label>
                            <span>{details?.influencerName || "N/A"}</span>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                        <div className="dataView">
                            <label>Plan Type</label>
                            <span>{details?.type || "N/A"}</span>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                        <div className="dataView">
                            <label>Status</label>
                            <span>{details?.isActive ? "Active" : "Inactive"}</span>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                        <div className="dataView">
                            <label>Start Date</label>
                            <span>{details?.startDate ? getFormatedDate(details?.startDate, "DD MMMM YYYY") : "N/A"}</span>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                        <div className="dataView">
                            <label>End Date</label>
                            <span>{details?.endDate ? getFormatedDate(details?.endDate, "DD MMMM YYYY") : "N/A"}</span>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                        <div className="dataView">
                            <label>Price</label>
                            <span>{details?.price ? RUPEES_SYMBOL + formatPrice(parseFloat(details.price)) : "N/A"}</span>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                        <div className="dataView">
                            <label>Payment Status</label>
                            <span className={details?.paymentStatus === 'COMPLETED' ? "text-success fw-bold" : "text-danger fw-bold"}>{details?.paymentStatus || "N/A"}</span>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                        <div className="dataView">
                            <label>Order ID</label>
                            <span style={{ wordBreak: "break-all" }}>{details?.paymentId || "N/A"}</span>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                        <div className="dataView">
                            <label>Payment ID</label>
                            <span style={{ wordBreak: "break-all" }}>{details?.paymentId || "N/A"}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="card cretePlan p-4 mx-3">
                <div className="row">
                    <div className="col-12 mb-4">
                        <Typography variant="h4" component="h4" sx={{ fontSize: '18px' }}>
                            Quotas
                        </Typography>
                    </div>
                    <div className='col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12'>
                        <div className='borderBox'>
                            <Typography variant="h4" component="h4" sx={{ fontSize: '15px' }}>
                                Campaign Quotas
                            </Typography>
                            <Box className='numbBox'>
                                <div className='row g-3 align-items-center'>
                                    <div className='col-md-6 col-sm-6 col-6'>
                                        <Typography variant="p" component="p" sx={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.8)', fontWeight: '500', marginBottom: '0px' }}>
                                            Paid
                                        </Typography>
                                    </div>
                                    <div className='col-md-6 col-sm-6 col-6'>
                                        <p className="m-0">{details?.paid || 0}</p>
                                    </div>
                                    <div className='col-md-6 col-sm-6 col-6'>
                                        <Typography variant="p" component="p" sx={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.8)', fontWeight: '500', marginBottom: '0px' }}>
                                            Barter
                                        </Typography>
                                    </div>
                                    <div className='col-md-6 col-sm-6 col-6'>
                                        <p className="m-0">{details?.barter || 0}</p>
                                    </div>
                                    <div className='col-md-6 col-sm-6 col-6'>
                                        <Typography variant="p" component="p" sx={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.8)', fontWeight: '500', marginBottom: '0px' }}>
                                            Affiliate
                                        </Typography>
                                    </div>
                                    <div className='col-md-6 col-sm-6 col-6'>
                                        <p className="m-0">{details?.affiliate || 0}</p>
                                    </div>
                                    <div className='col-md-6 col-sm-6 col-6'>
                                        <Typography variant="p" component="p" sx={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.8)', fontWeight: '500', marginBottom: '0px' }}>
                                            Performance
                                        </Typography>
                                    </div>
                                    <div className='col-md-6 col-sm-6 col-6'>
                                        <p className="m-0">{details?.performance || 0}</p>
                                    </div>
                                </div>
                            </Box>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default DetailsInfluencerSubscription;
